/*  eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Box, Button, Dialog, Typography } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';

/* CSS */
/* import useStyles from '../Main.style'; */
const useStyles = makeStyles((theme) => ({
  warningModal: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: '360px',
    },
  },
  warningContent: {
    fontWeight: '400',
    color: '#616468',
  },
}));
const CalendarFilterWarning = ({ open, onClose, onContinue, onOpen, warning }) => {
  const styles = (theme) => ({
    root: {
      margin: 0,
      paddingBottom: theme.spacing(0),
      padding: theme.spacing(2),
    },
    closeButton: {
      color: theme.palette.grey[500],
    },
    WarningIcon: {
      color: '#f3aa1c',
    },
    warningContent: {
      '& .MuiTypography-h4': {
        fontWeight: '400',
        color: '#616468',
      },
    },
  });
  const classes = useStyles();

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex">
            <Box>
              <WarningIcon className={classes.WarningIcon} />
            </Box>
            <Box ml={1.5}>
              <Typography variant="h2">Warning</Typography>
            </Box>
          </Box>

          <Box>
            {onClose ? (
              <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                <CloseIcon />
              </IconButton>
            ) : null}
          </Box>
        </Box>
      </MuiDialogTitle>
    );
  });

  const DialogContent = withStyles((theme) => ({
    root: {
      paddingTop: theme.spacing(1),
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);

  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
  }))(MuiDialogActions);

  function handleClose() {
    onClose();
  }

  function handleContinue() {
    onContinue();
  }

  function handleOpen() {
    onOpen();
  }

  if (!open) {
    return null;
  }
  return (
    <>
      <Dialog
        className={classes.warningModal}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Modal title
        </DialogTitle>
        <DialogContent>
          <Typography variant="h4" className={classes.warningContent}>
            {warning}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
          <Button onClick={handleContinue} autoFocus>
            Click to continue
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default CalendarFilterWarning;
